export default __webpack_public_path__ + "static/media/carousel3.1497d8b7.jpg";